export default "__VITE_ASSET__Cf207Rii__"